<template>
  <div class="col-xs-10 col-sm-10 col-md-10 col-lg-10 mt-1">
    <a-input
      v-model="inputValue"
      :placeholder="generatedPlaceholder"
    ></a-input>
  </div>
</template>

<script>
export default {
  name: 'FormInput',
  props: {
    value: {
      type: [String, Number],
      default: '',
    },
    label: {
      type: String,
      required: true,
    },
    // Optional custom placeholder that overrides the auto-generated one
    placeholder: {
      type: String,
      default: null,
    },
  },
  computed: {
    inputValue: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      },
    },
    generatedPlaceholder() {
      // Use custom placeholder if provided, otherwise generate from label
      return this.placeholder || `Masukan ${this.label}`
    },
  },
}
</script>
